import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const MissionVisionSection = () => {
  return (
    <div className="container-fluid py-5">
      {/* Main Title */}
      <div className="row text-center">
        <div className="text-center mb-5">
          <h2 className="main-heading">Our <span className='text-danger'>Vision</span> And <span className='text-danger'>Mission</span></h2>
        </div>
      </div>

      {/* Mission Section */}
      <div className="row position-relative">
        {/* Gray Background Extension */}
        <div className="position-absolute end-0 top-0 h-100 d-none d-md-block"></div>
        
        {/* Mission Content Container */}
        <div className="col-12 position-relative">
          <div className="d-flex align-items-center">
            {/* Image */}
            <div className="position-relative" style={{ zIndex: 2, width: '200px', flexShrink: 0 }}>
              <img 
                src="/assets/icons/mission_1628441.png"
                alt="Mission"
                className="rounded-circle img-fluid"
                style={{ 
                  width: '200px',
                  height: '200px',
                  objectFit: 'cover'
                }}
              />
            </div>

            {/* Content starting from image */}
            <div className="ps-4" style={{ zIndex: 2 }}>
              <h2 className="mission-heading h3 mb-3">Mission</h2>
              <p className="mission-description text-muted mb-0">
              At the heart of our organization lies our commitment to excellence in packaging design, manufacturing, and customer service. We pioneer sustainable solutions and maintain rigorous quality standards through innovative research and development. By fostering strategic partnerships and investing in our workforce and technology, we continuously advance industry standards while minimizing environmental impact. Our dedication to quality, sustainability, and innovation drives us to exceed customer expectations and set new benchmarks in the packaging industry.              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Spacer */}
      <div className="my-5"></div>

      {/* Vision Section */}
      <div className="row position-relative mt-5">
        {/* Gray Background Extensions */}
        <div className="position-absolute start-0 top-0 h-100 d-none d-md-block" style={{ width: '65%' }}></div>
        <div className="position-absolute end-0 top-0 h-100 d-none d-md-block" style={{ width: '35%' }}></div>
        
        {/* Vision Content Container */}
        <div className="col-12 position-relative">
          <div className="d-flex align-items-center">
            {/* Content starting from left */}
            <div className="ps-4 " style={{ zIndex: 2, textAlign:'end'}}>
              <h2 className="vision-heading h3 mb-3">Vision</h2>
              <p className="vision-description text-muted mb-0">
              We will drive transformative business growth for our clients by delivering innovative, customized packaging solutions that seamlessly blend superior quality with environmental sustainability. Through our state-of-the-art manufacturing facilities and cutting-edge technology, we create packaging that not only meets but anticipates market demands. Our commitment to excellence extends beyond products to encompass comprehensive customer service, ensuring each client receives personalized attention and tailored solutions.               </p>
            </div>

            {/* Image */}
            <div className="position-relative ms-4" style={{ zIndex: 2, width: '200px', flexShrink: 0 }}>
              <img 
                src="assets/icons/vision_3775630.png"
                alt="Vision"
                className="rounded-circle img-fluid"
                style={{ 
                  width: '200px',
                  height: '200px',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionVisionSection;